import apiPaths from '../../api-paths';

export default {
    get(staffOriginal = null) {
        const url = staffOriginal
            ? `${apiPaths.CRM}/mailbox-settings/${staffOriginal}`
            : `${apiPaths.CRM}/mailbox-settings`;
        return axios.get(url);
    },
    getAdminMail() {
      return axios.get(`${apiPaths.CRM}/mailbox-settings/get-admin-mail`);
    },
    save(data) {
        return axios.post(`${apiPaths.CRM}/mailbox-settings`, data);
    },

    testConnection(data) {
        return axios.post(`${apiPaths.CRM}/mailbox-settings/test-connection`, data);
    },

    getStaffsMailBoxes(query = '') {
        return axios.get(`${ apiPaths.CRM }/mailbox-settings/staffs`);
    },
};
